
    (function () {
      var params = new URLSearchParams(window.location.search);

      // iOS Universal Link 落地：带 _ul 参数说明 App 未安装，前端 JS 重定向到 App Store
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|iPod/i.test(ua) && params.has('_ul')) {
        var appStoreUrl = 'https://apps.apple.com/us/app/keymart/id6757694906';
        window.location.href = appStoreUrl;
        return;
      }

      var MOBILE_ORIGIN = (import.meta.env && import.meta.env.VITE_MOBILE_REDIRECT_DOMAIN) || '';
      var WWW_URL = (import.meta.env && import.meta.env.VITE_WWW_URL) || '';
      var WWW_URL2 = (import.meta.env && import.meta.env.VITE_WWW_URL2) || '';

      var forceRedirect = params.get('redirect') === '1';

      var hostname = window.location.hostname;
      var host = window.location.host;
      var isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
      var isLanIp = /^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);

      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

      if (!MOBILE_ORIGIN) return;

      var isAlreadyOnMobileSite = window.location.origin === MOBILE_ORIGIN;
      if (isAlreadyOnMobileSite) return;

      // 解析两个 PC 官网域名
      var pcHosts = [];
      try {
        if (WWW_URL) pcHosts.push(new URL(WWW_URL).host);
      } catch (e) {}
      try {
        if (WWW_URL2) pcHosts.push(new URL(WWW_URL2).host);
      } catch (e) {}

      var shouldRedirectLocalTest = forceRedirect && (isLocalHost || isLanIp);
      var shouldRedirectPcHost = isMobile && pcHosts.indexOf(host) !== -1;

      if (shouldRedirectLocalTest || shouldRedirectPcHost) {
        var targetUrl = MOBILE_ORIGIN + window.location.pathname + window.location.search + window.location.hash;
        window.location.replace(targetUrl);
      }
    })();
  